interface EnvelopeType {
  openBack?: string;
}

interface LinerType {
  image?: string;
}

interface EnvelopeOpenFlapProps {
  envelope?: EnvelopeType;
  liner?: LinerType;
  linerShading?: string;
}

export const EnvelopeOpenFlap = ({envelope, liner, linerShading}: EnvelopeOpenFlapProps) => (
  <div className="env-wrapper open-flap env-2 env-final">
    <div className="env-group env-group__open-flap">
      <img className="env-img__open-flap env-group__open-flap-shading" src={linerShading} alt="" />
      <img className="env-img__open-flap" src={envelope?.openBack} alt="" />
      <img className="env-img__top-liner" src={liner?.image} alt="" />
    </div>
  </div>
);
